import { ErrorBoundary, Shadow, VStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { Box, FlatList } from 'native-base';
import React from 'react';

import { TableHeadContainer, TableHeadItem } from '../../../../../../components/TableHead';
import { BlockReasonModal } from '../../../../../NewApplication/Customer/components/BlockReasonModal';
import { flatListProps, tableHeadCustomerData } from '../../../../utils';
import { CustomerItemDataResponseProps, orderByProps } from '../../../../utils/types';
import { ItemSeparator } from '../../../ItemSeparator';
import { ItemTable } from '../ItemTable';
import { SkeletonItem } from '../SkeletonItem';

interface CustomerProps {
  orderBy: orderByProps;
  isLoading: boolean;
  isLoadingMore: boolean;
  error?: Error;
  response: CustomerItemDataResponseProps;
  refresher: () => void;
  onEndReached: () => void;
  skeletonItemCount: number;
  errorTags?: Error;
  isLoadingTags: boolean;
  refresherTags: () => void;
}

export const CustomerTable: React.FC<CustomerProps> = ({
  isLoading,
  orderBy,
  refresher,
  response,
  error,
  onEndReached,
  isLoadingMore,
  skeletonItemCount,
  errorTags,
  isLoadingTags,
  refresherTags,
}) => {
  return (
    <>
      <VStack
        space={Spacing['inline.nano']}
        px={{ base: 0, sm: Spacing['inline.xxs'] }}
        {...(error && { pb: Spacing['inline.xxxs'] })}>
        {!error && response && response?.data?.length > 0 && (
          <TableHeadContainer>
            {tableHeadCustomerData.map((item) => (
              <TableHeadItem
                key={item.title}
                {...item}
                {...(item.title === 'Nome' && { flex: 2 })}
                orderBy={orderBy}
              />
            ))}
          </TableHeadContainer>
        )}
        <Shadow level={2} borderTopRadius={BoxRadius.sm}>
          {isLoading && <SkeletonItem itemsCount={skeletonItemCount} />}
          {!isLoading && !error && response && response?.data?.length > 0 && (
            <FlatList
              {...flatListProps}
              data={response?.data}
              keyExtractor={(item) => item.accountNumber.toString()}
              ItemSeparatorComponent={ItemSeparator}
              onEndReached={onEndReached}
              ListFooterComponent={
                <Box py={Spacing['inline.quarck']}>{isLoadingMore && <SkeletonItem />}</Box>
              }
              renderItem={({ item }) => (
                <ItemTable
                  item={item}
                  errorTags={errorTags}
                  isLoadingTags={isLoadingTags}
                  refresherTags={refresherTags}
                />
              )}
            />
          )}
          {!isLoading && error && (
            <Box py={{ sm: Spacing['inline.md'] }}>
              <ErrorBoundary onRefresh={refresher} {...error} />
            </Box>
          )}
          {!isLoading && !error && response && response?.data?.length === 0 && (
            <Box py={{ sm: Spacing['inline.md'] }}>
              <ErrorBoundary
                onRefresh={refresher}
                errorIconOrIllustration="NotEmptyIllustration"
                errorTitle="Nenhuma informação encontrada."
                errorMessage="No momento não há dados disponíveis. Por favor, tente novamente mais tarde."
              />
            </Box>
          )}
        </Shadow>
      </VStack>
      <BlockReasonModal />
    </>
  );
};
